import './blog.css';
import EmptyPage from '../../components/empty-page/emptyPage';
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import fetchBlogsData, { blogCount } from './fetchBlogsFun/fetchBlogsData';
import deleteBlogsData from './deleteBlogFun/deleteBlog';
import { useNavigate, useParams } from 'react-router-dom';
import Dialog from '../../components/dialogModal/dialogModal';
import Pagination from '../../components/pagination/Pagination';
import { parsePurify } from '../../utils/parsePurify';
import Popup from '../../components/popup/Popup';

export default function BlogList() {
    const [blogData, setBlogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [rowId, setRowId] = useState('');
    const [pageNumber, setPageNumber] = useState(1);
    const [offSet, setOffSet] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const totalData = totalCount;
    const limit = 10;
    const navigate = useNavigate();
    const { mode } = useParams();

    useEffect(() => {
        fetchBlogsData(setBlogData, setLoading);
    }, []);

    useEffect(() => {
        blogCount(setTotalCount, setLoading);
    }, []);

    const tableHeader = ['Name', 'Short Description', 'Author', 'Action'];

    const handleDelete = async () => {
        const response = await deleteBlogsData(rowId, setLoading);
        if (response === 200) {
            setDeleteModal(false);
            fetchBlogsData(setBlogData, setLoading);
            setRowId('');
        }
    };

    const handleEdit = async (row) => {
        navigate(`/support/${mode}/blog/edit/${row._id}`);
    };

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            setPageNumber(+number);
            setOffSet(+offSetNumber);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    return (
        <>
            <div className='addBtnContainer'>
                <h1 className='supportHeader'>Blogs</h1>
                <button onClick={() => navigate(`/support/${mode}/blog/upload`)} className='blueBtn blogAddBtn'>
                    Add Blog
                </button>
            </div>
            <div className='table-top-container'>
                <div className='tableContainer'>
                    {blogData?.length === 0 ? (
                        <EmptyPage />
                    ) : (
                        <>
                            <table className='table'>
                                <thead className='tableHead'>
                                    <tr>
                                        {tableHeader.map((head, headIndex) => {
                                            return <th key={headIndex}>{head}</th>;
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {blogData?.map((row, rowIndex) => {
                                        return (
                                            <tr key={rowIndex} className='tableBodyRow'>
                                                <td className='ellipsisCell'>{row?.name}</td>
                                                <td className='ellipsisCell' style={{ width: '50%' }}>
                                                    {parsePurify(row?.shortDescription)}
                                                </td>
                                                <td>{row?.author?.name}</td>
                                                <td>
                                                    <div className='sendMessageBtn'>
                                                        <button
                                                            className='actBtn payoutBtn noWidth'
                                                            onClick={() => handleEdit(row)}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button
                                                            className='actBtn billBtn noWidth'
                                                            onClick={() => {
                                                                setDeleteModal(true);
                                                                setRowId(row._id);
                                                            }}
                                                        >
                                                            Delete
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <div className='responsiveCardContainer'>
                                {blogData?.map((row, rowIndex) => (
                                    <div key={rowIndex} className='responsiveCard'>
                                        <div className='cardContent'>
                                            <p>
                                                <strong>{tableHeader[0]}</strong> {row?.name}
                                            </p>
                                            <p>
                                                <strong>{tableHeader[1]}</strong> {parsePurify(row?.shortDescription)}
                                            </p>
                                            <p>
                                                <strong>{tableHeader[1]}</strong> {row?.author?.name}
                                            </p>
                                            <div className='sendMessageBtn'>
                                                <button
                                                    className='actBtn payoutBtn noWidth'
                                                    onClick={() => handleEdit(row)}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    className='actBtn billBtn noWidth'
                                                    onClick={() => {
                                                        setDeleteModal(true);
                                                        setRowId(row._id);
                                                    }}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalData}
                    offSet={offSet}
                    pageNumber={pageNumber}
                    limit={limit}
                />
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                    </div>
                )}
                {deleteModal && (
                    <Popup isOpen={deleteModal} onClose={() => setDeleteModal(false)}>
                        <div className='modal-content'>
                            <header>
                                <h3>Delete Confirmation!</h3>
                            </header>
                            <div>
                                <p className='confirmationText'>Are you sure?</p>
                                <p className='confirmationMessage'>You want to delete this Date.</p>
                            </div>
                            <button className='confirm-btn' onClick={handleDelete}>
                                Yes
                            </button>
                            <button
                                onClick={() => {
                                    setDeleteModal(false);
                                    setRowId('');
                                }}
                                className='cancel-btn'
                            >
                                No
                            </button>
                        </div>
                    </Popup>
                )}
            </div>
        </>
    );
}
